import { Marker, Popup, useMapEvents } from "react-leaflet";

export const MapSelectCurrent = ({ position, setPosition, popup }) => {
    useMapEvents({
        click(e) {
            setPosition({
                lat: e.latlng.lat,
                lng: e.latlng.lng,
            });
        },
    });

    // ⛔ JANGAN render marker kalau position belum ada
    if (
        !position ||
        typeof position.lat !== "number" ||
        typeof position.lng !== "number"
    ) {
        return null;
    }

    return (
        <Marker position={[position.lat, position.lng]}>
            {popup && <Popup>{popup}</Popup>}
        </Marker>
    );
};